// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'received-loan-payment.page.title': 'Loan Payments',
    'received-loan-payment.page.search_results': 'Search Results',
    'received-loan-payment.page.create.title': 'Record Payment',
    'received-loan-payment.page.search.title': 'Find Loan Payments',
    'received-loan-payment.page.title.redo': 'Redo Payment',
    'received-loan-payment.page.view.title': 'View Loan Payment',
    'received-loan-payment.page.all': 'All',

    'received-loan-payment.button.cancel': 'Cancel',
    'received-loan-payment.button.select': 'Select',
    'received-loan-payment.button.find': 'Find Loan Payments',
    'received-loan-payment.button.search': 'Apply',
    'received-loan-payment.button.create': 'Record Payment',
    'received-loan-payment.button.new': 'New Loan Payment',
    'received-loan-payment.button.save': 'Save Changes',
    'received-loan-payment.button.delete': 'Permanently Delete',
    'received-loan-payment.button.edit': 'Edit',
    'received-loan-payment.button.restore': 'Restore',
    'received-loan-payment.button.reset': 'Reset',
    'received-loan-payment.button.payments': 'Payment History',
    'received-loan-payment.button.void': 'Void Payment',
    'received-loan-payment.button.rollback': 'Rollback Payment',
    'received-loan-payment.button.redo': 'Redo',

    'received-loan-payment.placeholder.search': 'Search received loan payments',

    'received-loan-payment.message.no_payment': 'No payment has been recorded as yet.',
    'received-loan-payment.message.overpayment': 'Remember to adjust the balance outstanding with any additional interest and penalty on the loan',

    'received-loan-payment.link.create_first_received_loan_payment': 'Click here to create your first received loan payment',
    'received-loan-payment.link.received_loan_payments': ' Return to Received Loan Payments',
    'received-loan-payment.link.retry': 'Click here to retry',

    'received-loan-payment.checkbox.all': 'Check All',
    'received-loan-payment.checkbox.actions_label': 'with selected',

    'received-loan-payment.label.received_loan_name': 'Received Loan',
    'received-loan-payment.label.transaction_date': 'Transaction Date',
    'received-loan-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'received-loan-payment.label.transaction_number': 'Transaction Number',
    'received-loan-payment.label.is_reconciled': 'Is Reconciled',
    'received-loan-payment.label.payment_method': 'Payment Method',
    'received-loan-payment.label.reference_code': 'Reference Code',
    'received-loan-payment.label.memo': 'Memo',
    'received-loan-payment.label.currency_name': 'Currency',
    'received-loan-payment.label.currency_principal_amount_in_cents': 'Principal Amount',
    'received-loan-payment.label.currency_interest_amount_in_cents': 'Interest Amount',
    'received-loan-payment.label.currency_grand_total_in_cents': 'Grand Total',
    'received-loan-payment.label.cancelled_on': 'Cancelled On',
    'received-loan-payment.label.cancellation_reason': 'Cancellation Reason',
    'received-loan-payment.label.received_loan_payment_status': 'Received Loan Payment Status',
    'received-loan-payment.label.reason_for_void': 'Reason for voiding',
    'received-loan-payment.label.rollback_reason': 'Reason for rollback',
    'received-loan-payment.label.issue_credit_memo': 'Give store credit?',
    'received-loan-payment.label.status': 'Status',
    'received-loan-payment.label.available_credit': 'Available Credit',
    'received-loan-payment.label.use_credit': 'Use Available Credit',

    'received-loan-payment.sort.field_label': 'Field',
    'received-loan-payment.sort.direction_label': 'Direction',
    'received-loan-payment.sort.direction_ascending': 'Ascending',
    'received-loan-payment.sort.direction_descending': 'Descending',

    'received-loan-payment.modal.title.received_loan_payment_void': 'Void Payment',
    'received-loan-payment.modal.title.received_loan_payment_rollback': 'Rollback Payment',
    'received-loan-payment.modal.title.overpayment': 'Overpayment',

    'received-loan-payment.modal.message.overpayment': 'Payment is more than the amount outstanding, please review the amount due or adjust the amount outstanding by {amount} to reflect the new balance.',

    'received-loan-payment.success.message.received_loan_payment_created': 'Your received loan payment has been created',
    'received-loan-payment.success.message.received_loan_payment_updated': 'Your received loan payment has been updated',
    'received-loan-payment.success.message.received_loan_payment_voided': 'Your loan payment has been voided',
    'received-loan-payment.success.message.received_loan_payment_rolled_back': 'Your loan payment has been rolled back',
    'received-loan-payment.success.message.received_loan_payment_redone': 'Your loan payment has been redone',

    'received-loan-payment.error.message.error_loading_page': 'Sorry, there was an error loading received loan payment.| Sorry, there was an error loading received loan payments.',
};
